<woa-field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [readOnly]="readOnly()" [disabled]="disabled()" [defaultInput]="input" (onActivateLink)="onActivateLink.emit()">
    <div class="phone-number-field">
        <input #input class="phone-number-field-input" [attr.id]="inputId()"
               [value]="displayValue()" (input)="handleInputEvent($event)"
               type="text" inputmode="tel" [attr.autocomplete]="autocomplete()"
               [attr.pattern]="'[+]?\d{10,30}'" [readOnly]="readOnly()"
               (keydown)="validateCharacter($event)" (keyup)="correctInput($event)"
               [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()">
        @if (!valueSignal()) {
            <div class="phone-number-field-placeholder">
                {{ placeholder() | translate: translationParams() }}
            </div>
        }
    </div>
</woa-field>
